import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import OpacityAnimation from '../../../../components/OpacityAnimation';
import useGetGeneralAppData from '../../../../hooks/useGetGeneralAppData';
import { MappedReclamationType } from '../../types';
import {
  Card,
} from './styles';

interface ListInterface {
  filteredList: MappedReclamationType[];
  activeSidebar: string | null,
  returnLink: string | null,
}

export default function List({
  filteredList,
  activeSidebar,
  returnLink,
}: ListInterface) {
  const navigate = useNavigate();
  const { companyCode } = useGetGeneralAppData();

  return (
    <Container>
      <Row xs={1} md={2} lg={2}>
        {filteredList?.map((rcl) => (
          <Col key={rcl.consultCode + rcl.date + Math.random()}>
            <OpacityAnimation delay={0.1}>
              <Card onClick={() => navigate(`/consults/result/${rcl.consultCode}?codEmpresa=${companyCode}&activeSidebar=${activeSidebar ?? 'Home'}&returnLink=${decodeURIComponent(returnLink ?? '/')}${rcl.routeType === 'MULTI ROTAS' ? '&mr' : ''}`)}>
                <div className="info">
                  <div className="card-title">
                    <strong>{rcl.consultCode}</strong>
                  </div>
                  <span>
                    Gerada em {rcl.date}
                  </span>
                  <span>
                    {rcl.workCity}
                    {'←→'}
                    {rcl.homeCity}
                    {' '}
                    ({rcl.uf})
                  </span>
                  <span>
                    Funcionário:
                    {' '}
                    {rcl.employeeName}
                  </span>
                </div>
              </Card>
            </OpacityAnimation>
          </Col>
        ))}
      </Row>
    </Container>
  );
}
